import React, { useState } from "react";
import { ScentSelector } from "../product/ScentSelector";

interface BundleProfileSelectorProps {
  onChange: (value: string) => void;
  profiles: string[];
  value: string;
}

export const BundleProfileSelector = ({
  onChange,
  profiles,
  value,
}: BundleProfileSelectorProps) => {
  const [focused, setFocused] = useState(value);

  return (
    <div className="space-y-4 rounded border border-solid border-primary-300 bg-primary-50 p-4">
      <p className="body">
        <span className="font-bold">Pick Scent Profile:</span>{" "}
        <span>{focused}</span>
      </p>
      <ScentSelector
        value={value}
        scents={profiles}
        onScentSelect={(profile) => {
          onChange(profile);
        }}
        onScentFocus={(profile) => {
          setFocused(profile);
        }}
        onScentUnfocus={() => setFocused(value)}
      />
    </div>
  );
};
